import {useGlobals} from '../../../../../globalPropsContext';
import {AddToCartActionStatus} from '../../../../../constants';
import {AddToCartState} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/AddToCartService/constants';

export const useAddToCartState = (productId: string) => {
  const {productsManifest, addedToCartStatus} = useGlobals();

  const hasAddToCartUnselectedOptionError =
    addedToCartStatus[productId] === AddToCartActionStatus.UNSELECTED_OPTION_ERROR;

  const isAddToCartEnabled = () => {
    if (hasAddToCartUnselectedOptionError) {
      return false;
    }

    const {addToCartState} = productsManifest[productId];
    const isEnabledState = addToCartState === AddToCartState.ENABLED;
    const isPreOrderState = addToCartState === AddToCartState.PRE_ORDER;
    return isEnabledState || isPreOrderState;
  };

  return {isAddToCartEnabled, hasAddToCartUnselectedOptionError};
};
